import React, { useEffect } from "react";

import "../App.css"; // Add your global styles here
import useZoomLevel from "../hooks/useZoomLevel";

const AppWrapper = ({ children }) => {
    const zoomLevel = useZoomLevel();

    useEffect(() => {
        if (zoomLevel > 125) {
            document.body.classList.add("disable-responsive");
        } else {
            document.body.classList.remove("disable-responsive");
        }
    }, [zoomLevel]);

    return <>{children}</>; // Render the rest of your app
};

export default AppWrapper;
